import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.25 13.964v-2.666zM1.575 2.954a.7.7 0 0 0-.983.108l-.438.547a.7.7 0 0 0 .109.984L12.296 14l10.453 8.172 3.677 2.874a.7.7 0 0 0 .984-.108l.437-.546A.7.7 0 0 0 28 23.95a.68.68 0 0 0-.261-.544l-4.46-3.487.297-1.268c.148-.63.224-1.277.224-1.924V10.15a1.75 1.75 0 0 0-1.716-1.75c-.981-.018-1.784.803-1.784 1.784V14h-.35V6.29c0-.98-.803-1.802-1.784-1.783a1.75 1.75 0 0 0-1.716 1.75V14h-.35V4.585c0-.982-.803-1.803-1.784-1.785A1.75 1.75 0 0 0 12.6 4.55v7.022l-.35-.274V6.335c0-.982-.803-1.803-1.784-1.785A1.75 1.75 0 0 0 8.75 6.3v2.262zm7.175 10.94v2.73l-1.385-1.903a1.75 1.75 0 0 0-2.83 2.058l5.495 7.556a2.1 2.1 0 0 0 1.699.865h8.644a2.1 2.1 0 0 0 1.71-.883z"
    }, null, -1)
  ])))
}
export default { render: render }